module.exports = __webpack_public_path__ + "89da9006d1fe6f8b7c7d2313fb68cdb0.png";